// UserFollowingGridCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import UniversalComponent from '../component/UniversalComponent.jsx';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const UserFollowingGridCategoryRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <UniversalComponent
        filename="Container_FollowingUserGridList"
        importer={
          /* #__LOADABLE__ */ () =>
            import('../container/FollowingUserGridList.js')
        }
      />
    </>
  );
};

export default UserFollowingGridCategoryRoute;
